import Vue from "vue";
import Vuex from "vuex";
import login from "./modules/login";
import auth from "./modules/authority";
import createLogger from "@/plugins/logger";
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    login,
    auth
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
});
